/* Common Imports */

import React from "react";
import { makeStyles } from "@material-ui/core/styles";

/* Component Imports */

import { Paper, Typography } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

/* Define all styles */

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "1.5rem",
    marginBottom: "2rem",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    width: "100%",
  },
  heading: {
    color: "#202020",
    fontWeight: "400",
    fontSize: "1.5rem",
    lineHeight: "2.25rem",
  },
  ul: {
    marginTop: "0rem",
    paddingLeft: "1.5rem",
    wordBreak: "break-word",
  },
  listItem: {
    color: "#666666",
    fontWeight: 400,
    fontSize: "1rem",
    lineHeight: "1.3rem",
    letterSpacing: "0.009rem",
  },
}));

const AboutPropertyAndLocation = (props) => {
  const classes = useStyles();

  if (!props.loading) {
    return (
      <React.Fragment>
        <Paper elevation={2} className={classes.paper}>
          <Typography variant="body2" component="p" className={classes.heading}>
            About Property
          </Typography>
          <ul className={classes.ul}>
            {props.aboutProperty
              ? props.aboutProperty.map((object, key) => (
                  <li key={key} className={classes.listItem}>
                    {object}
                  </li>
                ))
              : "Unable to fetch data :("}
          </ul>
          <Typography
            id="about-location"
            variant="body2"
            component="p"
            className={classes.heading}
          >
            About Location
          </Typography>
          <Typography
            variant="body2"
            component="p"
            className={classes.listItem}
          >
            {props.aboutLocation
              ? props.aboutLocation
              : "Unable to fetch data :("}
          </Typography>
        </Paper>
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <Paper elevation={2} className={classes.paper}>
          <Skeleton style={{ marginBottom: "1rem" }}>
            <Typography
              variant="body2"
              component="p"
              className={classes.heading}
            >
              About Property
            </Typography>
          </Skeleton>
          <ul className={classes.ul}>
            <Skeleton height="1rem" width="100%">
              {props.aboutProperty
                ? props.aboutProperty.map((object, key) => (
                    <li key={key} className={classes.listItem}>
                      {object}
                    </li>
                  ))
                : "Unable to fetch data :("}
            </Skeleton>
          </ul>
          <Skeleton>
            <Typography
              variant="body2"
              component="p"
              className={classes.heading}
            >
              About Location
            </Typography>
          </Skeleton>
          <Skeleton>
            <Typography
              variant="body2"
              component="p"
              className={classes.listItem}
            >
              {props.aboutLocation
                ? props.aboutLocation
                : "Unable to fetch data :("}
            </Typography>
          </Skeleton>
        </Paper>
      </React.Fragment>
    );
  }
};

export default AboutPropertyAndLocation;
